<div class="fundo" role="dialog" aria-modal="true" [attr.aria-label]="titulo">
  <div class="modal">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true">
        <svg class="i" viewBox="0 0 24 24" *ngIf="encaixe"><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></svg>
        <svg class="i" viewBox="0 0 24 24" *ngIf="!encaixe && ehExame"><path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3" /><path d="M7.5 15h9" /></svg>
        <svg class="i" viewBox="0 0 24 24" *ngIf="!encaixe && !ehExame"><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4M12 12.5v5M9.5 15h5" /></svg>
      </div>
      <div class="cab-txt">
        <span class="eyebrow">Agenda · {{ ehExame ? 'Exame' : 'Consulta' }}</span>
        <b>{{ titulo }}</b>
        <span>{{ subtitulo }}</span>
      </div>
      <span class="selo warn" *ngIf="!encaixe && linha?.ieStatusAgenda === 'R'">Reservado</span>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <!-- Cartões sobre fundo cinza, como as etapas do Abrir Atendimento. -->
    <div class="corpo-ag">
      <div class="lado-pac">
        <!-- Paciente: busca da Fila (Atendimento/buscar-paciente) -->
        <section class="cartao" aria-label="Paciente">
          <h4 class="tit-secao">
            <svg class="i sm" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c.8-3.5 3.4-5.5 6.5-5.5s5.7 2 6.5 5.5M16 4.5a3.5 3.5 0 0 1 0 7M18 14.6c2 .6 3.2 2.6 3.5 5.4" /></svg>
            Paciente
          </h4>

          <app-agenda-paciente
            [bloqueado]="salvando"
            [inicial]="pacienteInicial"
            (pacienteMudou)="aoMudarPaciente($event)"
            (planoCarregado)="aoCarregarPlano($event)"
          ></app-agenda-paciente>

          <div class="alerta bad" *ngIf="duplicidadeExame" role="alert">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
            <div><b>Duplicidade:</b> {{ duplicidadeExame }}</div>
          </div>
        </section>

        <section class="cartao" aria-label="Cupons" *ngIf="paciente">
          <app-agenda-cupons [cdPessoaFisica]="paciente.cdPessoaFisica"></app-agenda-cupons>
        </section>
      </div>

      <div class="lado-ag">
        <!-- Encaixe: hora e duração digitadas; o novo agendamento mostra o horário escolhido. -->
        <section class="cartao" aria-label="Horário extra" *ngIf="encaixe">
          <h4 class="tit-secao">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></svg>
            Horário extra
          </h4>
          <div class="alerta warn">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z" /></svg>
            <div>O encaixe cria uma linha nova fora da grade, com a observação "ENCAIXE".
              {{ supervisor ? 'Liberado para a supervisão.' : 'Nesta unidade o encaixe é livre.' }}</div>
          </div>
          <div class="grid3">
            <div class="campo">
              <label for="agHora">Horário <span class="req">*</span></label>
              <input type="time" id="agHora" step="300" [(ngModel)]="hrInicio" />
            </div>
            <div class="campo">
              <label for="agDur">Duração</label>
              <select id="agDur" [(ngModel)]="nrMinutoDuracao">
                <option *ngFor="let d of duracoes" [ngValue]="d">{{ d }} min</option>
              </select>
            </div>
            <div class="campo">
              <span class="rot">Data</span>
              <input type="text" [value]="dataBr" disabled />
            </div>
          </div>
        </section>

        <section class="cartao" aria-label="Agendamento">
          <h4 class="tit-secao">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M7 3h8l4 4v14H7z" /><path d="M10 11h6M10 15h6" /></svg>
            Agendamento
          </h4>
          <div class="grid2">
            <div class="campo cheio" *ngIf="ehExame">
              <label for="agExame">Exame <span class="req">*</span></label>
              <div class="exame-sel" *ngIf="exame; else buscaExameTpl">
                <b>{{ exame.dsProcExame }}</b>
                <button type="button" class="link" (click)="removerExame()" [disabled]="salvando">Trocar</button>
              </div>
              <ng-template #buscaExameTpl>
                <div class="busca">
                  <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                  <input
                    type="search"
                    id="agExame"
                    placeholder="Buscar exame pelo nome (mínimo 3 caracteres)"
                    autocomplete="off"
                    [(ngModel)]="buscaExame"
                    (ngModelChange)="aoDigitarExame()"
                  />
                </div>
                <p class="dica" *ngIf="buscandoExame">Buscando exames...</p>
                <p class="dica" *ngIf="!buscandoExame && vazioExame">{{ vazioExame }}</p>
                <div class="lista-exames" *ngIf="exames.length">
                  <button type="button" *ngFor="let e of exames" (click)="escolherExame(e)">
                    {{ e.dsProcExame }}
                    <span class="selo warn" *ngIf="e.ieTemValor === 'N'" title="Nenhum preço cadastrado">sem valor</span>
                  </button>
                </div>
              </ng-template>
            </div>

            <div class="preparo cheio" *ngIf="ehExame && preparo">
              <ng-container *ngIf="preparo.pac"><h5>Preparo · orientação ao paciente</h5><p>{{ preparo.pac }}</p></ng-container>
              <ng-container *ngIf="preparo.usuario"><h5>Orientação ao atendente</h5><p>{{ preparo.usuario }}</p></ng-container>
            </div>

            <div class="campo cheio" *ngIf="!ehExame && especialidade?.mista">
              <label for="agEsp">Especialidade <span class="req">*</span></label>
              <select id="agEsp" [ngModel]="especialidade?.escolhida" (ngModelChange)="trocarEspecialidade($event)">
                <option [ngValue]="null">Selecione...</option>
                <option *ngFor="let e of especialidade?.opcoes" [ngValue]="e.cdEspecialidade">
                  {{ e.dsEspecialidade }}{{ e.ieTitular === 'S' ? ' (titular da agenda)' : '' }}
                </option>
              </select>
              <p class="dica">Esta agenda atende {{ especialidade?.opcoes?.length }} especialidades. A escolhida decide preço e duplicidade.</p>
            </div>

            <div class="campo">
              <label for="agConv">Convênio <span class="req">*</span></label>
              <select id="agConv" [ngModel]="cdConvenio" (ngModelChange)="trocarConvenio($event)" [disabled]="!paciente || !convenios.length">
                <option [ngValue]="null">{{ !paciente ? 'Escolha o paciente primeiro' : 'Selecione...' }}</option>
                <option *ngFor="let c of convenios; trackBy: trackCodigo" [ngValue]="c.codigo">{{ c.descricao }}</option>
              </select>
              <p class="dica" *ngIf="conveniosCarregados && !convenios.length">Nenhum convênio liberado para este médico nesta unidade</p>
            </div>

            <div class="campo">
              <label for="agCat">Categoria <span class="req">*</span></label>
              <select
                id="agCat"
                [ngModel]="cdCategoria"
                (ngModelChange)="trocarCategoria($event)"
                [disabled]="!!permitidas.bloqueio || carregandoCategorias"
              >
                <option [ngValue]="null">{{ carregandoCategorias ? 'Carregando...' : permitidas.bloqueio || 'Selecione...' }}</option>
                <option *ngFor="let c of permitidas.lista; trackBy: trackCodigo" [ngValue]="'' + c.codigo">{{ c.descricao }}</option>
              </select>
            </div>

            <div class="cheio" *ngIf="aviso224">
              <div class="alerta bad">
                <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
                <div><b>{{ aviso224 }}.</b> O Cartão de Benefícios (224) só aceita a categoria do plano ativo do paciente; use Particular ou ofereça a adesão.</div>
              </div>
            </div>

            <div class="campo">
              <label for="agCls">Classificação</label>
              <select id="agCls" [ngModel]="ieClassifAgenda" (ngModelChange)="trocarClassif($event)">
                <option *ngFor="let o of opcoesClassif" [value]="o.valor" [disabled]="o.desabilitada">{{ o.rotulo }}</option>
              </select>
            </div>

            <div class="campo">
              <label for="agCanal">Canal de contato <span class="req">*</span></label>
              <select id="agCanal" [(ngModel)]="cdCanal">
                <option [ngValue]="null">Selecione...</option>
                <option *ngFor="let c of canais; trackBy: trackCodigo" [ngValue]="c.codigo">{{ c.descricao }}</option>
              </select>
            </div>

            <div class="cheio" *ngIf="avisoRetorno">
              <div class="alerta" [ngClass]="supervisor ? 'warn' : 'bad'">
                <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
                <div>
                  <b>{{ avisoRetorno }}</b>
                  {{ supervisor ? ' Supervisão pode passar do limite; fica registrado.' : ' Escolha outro dia ou peça à supervisão.' }}
                </div>
              </div>
            </div>

            <div class="campo cheio">
              <label for="agObs">Observação</label>
              <textarea id="agObs" class="obs" rows="1" maxlength="500" [(ngModel)]="dsObservacao" placeholder="Opcional"></textarea>
            </div>
          </div>
        </section>

        <!-- Resumo no formato da confirmação do Abrir Atendimento; o preço fecha o cartão. -->
        <section class="cartao resumo" aria-label="Resumo">
          <h4 class="tit-secao">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" /><rect x="9" y="3" width="6" height="4" rx="1" /><path d="M9 12h6M9 16h4" /></svg>
            Resumo
          </h4>
          <dl class="resumo-grid">
            <div><dt>Data/Hora</dt><dd>{{ dataHoraResumo }}</dd></div>
            <div><dt>Médico</dt><dd [title]="nomeMedico">{{ nomeMedico || '—' }}</dd></div>
            <div *ngIf="nomeUnidade"><dt>Unidade</dt><dd>{{ nomeUnidade }}</dd></div>
            <div><dt>{{ ehExame ? 'Exame' : 'Especialidade' }}</dt><dd [title]="itemResumo">{{ itemResumo || '—' }}</dd></div>
            <div><dt>Classificação</dt><dd>{{ classifSelecionada?.rotulo || '—' }}</dd></div>
            <div><dt>Convênio</dt><dd [title]="convenioResumo.tooltip">{{ convenioResumo.sub ? convenioResumo.linha1 + ' · ' + convenioResumo.sub : (convenioResumo.linha1 || '—') }}</dd></div>
          </dl>

          <!-- O preço depende de convênio e categoria; aparece logo que os dois estão escolhidos. -->
          <div
            class="preco"
            role="status"
            [class.sem]="!faltaParaPreco && !carregandoPreco && !!precoInfo?.sem"
            [class.com-valor]="!faltaParaPreco && !carregandoPreco && !!precoInfo && !precoInfo.sem"
          >
            <span class="rot-preco">Valor</span>
            <span class="preco-txt" *ngIf="faltaParaPreco">{{ faltaParaPreco }}</span>
            <span class="preco-txt" *ngIf="!faltaParaPreco && carregandoPreco">Consultando o preço...</span>
            <ng-container *ngIf="!faltaParaPreco && !carregandoPreco && precoInfo">
              <span class="preco-txt">{{ precoInfo.texto }}</span>
              <b>{{ precoInfo.sem ? 'Sem preço' : precoInfo.valor }}</b>
            </ng-container>
          </div>
        </section>

        <div class="alerta bad" *ngIf="erro" role="alert">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
          <div>{{ erro }}</div>
        </div>
      </div>
    </div>

    <div class="modal-rod">
      <span class="msg" *ngIf="faltando.length">
        <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></svg>
        Falta: {{ faltando.join(', ') }}
      </span>
      <button type="button" class="btn btn-contorno" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button type="button" class="btn btn-primario" (click)="salvar()" [disabled]="!podeSalvar">
        <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
        {{ salvando ? 'Gravando...' : encaixe ? 'Criar encaixe' : 'Agendar' }}
      </button>
    </div>
  </div>
</div>
